import { IUserPreferences } from '@/Services/SsrService/getUserPreferences';
import { useContextSelector } from 'use-context-selector';
import { GlobalSiteSettingsContext } from '@/Context/GlobalSiteSettings';

// ----------------------------- CONTINUE -----------------------------
export function useUserPreferencesState<T extends keyof IUserPreferences>(key: T) {
  return useContextSelector(GlobalSiteSettingsContext, v => v.state.userPreferences[key]);
}
